module.exports = __webpack_public_path__ + "static/media/bg_01.b526b7cb.png";